import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { CaretRight, ChartLineUp, Users, Target, Robot, Sparkle, ChatCircleDots, Brain, Cpu, Lightning, Atom, Lightbulb, MagicWand, Gear, Flask, Binoculars } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const projects = [
  {
    id: 1,
    title: "GEN Rentals",
    subtitle: "#1 Generator Rental Provider",
    image: "/projects/project1.png"
  },
  {
    id: 2,
    title: "VFINAX Tax Consultant",
    subtitle: "Professional Accounting Ally",
    image: "/projects/project2.png"
  },
  {
    id: 3,
    title: "FVAGITO Dining",
    subtitle: "Elevating Dining Experience",
    image: "/projects/project3.png"
  },
  {
    id: 4,
    title: "Nutsby Fitness",
    subtitle: "Premium Supplements Store",
    image: "/projects/project4.png"
  }
];

const Hero = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (!isMaximized) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % projects.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isMaximized]);

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  return (
    <section className="hero">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="hero-left">
            <h1 className="hero-title">
              <span>Custom Web App</span> Development Services for<br />
              <span className="accent-text">Scalable Growth</span>
            </h1>
            
            <p className="hero-description">
              At Cabptoid, we build high-performance, secure, and scalable web<br />
              applications tailored to your business goals <span className="highlight-ai">with AI Integration</span>. From dynamic<br />
              portals to enterprise-grade platforms, we deliver responsive and reliable solutions with<br />
              modern UI/UX and robust architecture.
            </p>

            <div className="hero-actions">
              <Button onClick={() => navigate('/industries')} className="quote-button">
                Get Started <CaretRight size={20} weight="bold" />
              </Button>
            </div>
          </Col>

          <Col lg={5} className="hero-right mt-5 mt-lg-0">
            <div 
              className={`slideshow-frame ${isMaximized ? 'maximized' : 'minimized'}`}
              onClick={toggleMaximize}
            >
              {projects.map((project, index) => (
                <div 
                  key={project.id} 
                  className={`slide ${index === currentSlide ? 'active' : ''}`}
                  style={{ backgroundImage: `url(${project.image})` }}
                >
                  <div className="slide-overlay">
                     <div className="slide-info">
                        <h3>{project.title}</h3>
                        <p>{project.subtitle}</p>
                     </div>
                  </div>
                </div>
              ))}
              
              {!isMaximized && (
                <div className="slide-indicators">
                  {projects.map((_, index) => (
                    <span 
                      key={index} 
                      className={`indicator ${index === currentSlide ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentSlide(index);
                      }}
                    />
                  ))}
                </div>
              )}

              <div className="click-hint">
                 {isMaximized ? 'Click to Minimize' : 'Click to View Full'}
              </div>
            </div>

            <div className="stats-container">
              <div className="stat-card card-efficiency">
                <div className="stat-icon"><Target size={24} weight="duotone" color="#3b82f6" /></div>
                <div className="stat-info">
                  <span className="stat-label">Efficiency</span>
                  <span className="stat-value">94%</span>
                </div>
              </div>

              <div className="stat-card card-leads">
                <div className="stat-icon"><Users size={24} weight="duotone" color="#10b981" /></div>
                <div className="stat-info">
                  <span className="stat-label">New Leads</span>
                  <span className="stat-value">1,420 <small>+18%</small></span>
                </div>
              </div>

              <div className="stat-card card-revenue">
                <div className="stat-icon"><ChartLineUp size={24} weight="duotone" color="#8b5cf6" /></div>
                <div className="stat-info">
                  <span className="stat-label">Growth</span>
                  <span className="stat-value">$84k <small>+24%</small></span>
                </div>
              </div>
            </div>

            {/* AI Sprinkles */}
            <div className="ai-sprinkles-container">
              <div className="ai-sprinkle s1"><Robot size={58} weight="duotone" /></div>
              <div className="ai-sprinkle s2"><Sparkle size={38} weight="fill" /></div>
              <div className="ai-sprinkle s3"><ChatCircleDots size={42} weight="duotone" /></div>
              <div className="ai-sprinkle s4"><Brain size={65} weight="duotone" /></div>
              <div className="ai-sprinkle s5"><Cpu size={38} weight="duotone" /></div>
              <div className="ai-sprinkle s6"><Lightning size={32} weight="fill" /></div>
              <div className="ai-sprinkle s7"><Sparkle size={28} weight="fill" /></div>
              <div className="ai-sprinkle s8"><Atom size={40} weight="duotone" /></div>
              <div className="ai-sprinkle s9"><Lightbulb size={42} weight="duotone" /></div>
              <div className="ai-sprinkle s10"><MagicWand size={36} weight="duotone" /></div>
              <div className="ai-sprinkle s11"><Gear size={30} weight="duotone" /></div>
              <div className="ai-sprinkle s12"><Flask size={28} weight="duotone" /></div>
              <div className="ai-sprinkle s13"><Binoculars size={26} weight="duotone" /></div>
              <div className="ai-sprinkle s14"><Robot size={45} weight="duotone" /></div>
              <div className="ai-sprinkle s15"><Robot size={35} weight="duotone" /></div>
              <div className="ai-sprinkle s16"><Sparkle size={30} weight="fill" /></div>
              <div className="ai-sprinkle s17"><Brain size={40} weight="duotone" /></div>
              <div className="ai-sprinkle s18"><Robot size={50} weight="duotone" /></div>
              <div className="ai-sprinkle s19"><ChatCircleDots size={35} weight="duotone" /></div>
              <div className="ai-sprinkle s20"><MagicWand size={45} weight="duotone" /></div>
            </div>
          </Col>
        </Row>
      </Container>
      
      <div className="hero-overlay"></div>
    </section>
  );
};

export default Hero;
